var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "fieldset",
    {
      staticClass: "checkbox",
      class: {
        "checkbox--inline": _vm.inline
      }
    },
    [
      _vm.legend
        ? _c("legend", [
            _c("span", {
              directives: [
                {
                  name: "sanitize",
                  rawName: "v-sanitize",
                  value: _vm.legend,
                  expression: "legend"
                }
              ]
            }),
            _vm._v(" "),
            _vm.legendOption
              ? _c("span", {
                  directives: [
                    {
                      name: "sanitize",
                      rawName: "v-sanitize",
                      value: _vm.legendOption,
                      expression: "legendOption"
                    }
                  ],
                  staticClass: "optional"
                })
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.options, function(option, index) {
        return _c(
          "div",
          {
            key: option.value,
            staticClass: "checkbox-area",
            class: {
              "checkbox-area--block": _vm.vertical
            }
          },
          [
            _c("input", {
              attrs: {
                type: "checkbox",
                id: _vm.uniqueId + "-" + index + "-" + option.value,
                name: _vm.name,
                required: _vm.required,
                disabled: _vm.disabled,
                autocomplete: "off"
              },
              domProps: {
                value: option.value,
                checked: Array.isArray(_vm.value)
                  ? _vm.value.includes(option.value)
                  : false
              },
              on: { change: _vm.onChange }
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                attrs: { for: _vm.uniqueId + "-" + index + "-" + option.value }
              },
              [
                _c("span", {
                  directives: [
                    {
                      name: "sanitize",
                      rawName: "v-sanitize",
                      value: option.label,
                      expression: "option.label"
                    }
                  ]
                }),
                _vm._v(" "),
                option.description
                  ? _c("small", {
                      directives: [
                        {
                          name: "sanitize",
                          rawName: "v-sanitize",
                          value: option.description,
                          expression: "option.description"
                        }
                      ]
                    })
                  : _vm._e()
              ]
            )
          ]
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }